import React, { useState, useEffect, useMemo } from "react";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import {
  deleteSales,
  getSalesByTransType,
} from "../../services/SalesApiServices";
import SalesReturnModal from "../../components/transactions/modal/SalesReturnModal";
import { useDispatch, useSelector } from "react-redux";
import { InvSales } from "../../core/json/invSales";
import {
  fetchCustomer,
  fetchProduct,
  fetchSettings,
} from "../../redux/userSetting";
import { fetchBranchSettings } from "../../redux/settingbyBranch";
import { getWareHouseList } from "../../services/MasterApiServices";
import {
  TransactionScreen,
  SALES_PAYMENTS,
} from "../../components/transactions/list";
import { dateOf, dmy, intg, money, num } from "../../components/report/reportFormat";

const SalesReturn = () => {
  const [salesData, setsalesData] = useState([]);
  const [updateData, setUpdateData] = useState([]);
  const [modalMode, setModalMode] = useState("add");
  const [modalOpen, setModalOpen] = useState(false);
  const dispatch = useDispatch();
  const { branch } = useSelector((state) => state.branchlist);
  const { userId } = useSelector((state) => state.userauth);
  const [wareHouseList, setWareHouseList] = useState([]);
  const { menuItems } = useSelector((state) => state.amc);
  const [permit, setpermit] = useState();
  const { customerList } = useSelector((state) => state.usersetting);

  useEffect(() => {
    setpermit(
      menuItems?.menuPermissions?.find((e) => e.menu.name == "Sales Invoice")
    );
  }, []);
  useEffect(() => {
    dispatch(fetchProduct(branch));
    dispatch(fetchCustomer(branch));
    dispatch(fetchSettings(branch));
    dispatch(fetchBranchSettings(branch.guid));
    handlesalesData();
  }, [branch]);

  useEffect(() => {
    const fetchWarehouses = async () => {
      try {
        const response = await getWareHouseList();
        setWareHouseList(response);
      } catch (err) {
        console.error("Failed to fetch warehouses:", err);
      }
    };
    fetchWarehouses();
  }, []);

  // Fetch sales returns data
  const handlesalesData = async () => {
    try {
      const response = await getSalesByTransType(branch, 3);
      const sales = Array.isArray(response.data) ? response.data : [];
      setsalesData(sales);
    } catch (error) {
      console.error(
        "Failed to fetch sales return",
        error?.response?.data?.Message || "something went wrong"
      );
    }
  };

  const handleEditClick = async (guid) => {
    try {
      const response = getsalesInvoiceByGuid(guid);
      setUpdateData(response);
      setModalMode("edit");
      setModalOpen(true);
    } catch (error) {
      console.error(
        "Error fetching sales return by GUID",
        error?.response?.data?.Message || "something went wrong"
      );
    }
  };
  function getsalesInvoiceByGuid(guid) {
    const filteredsales = salesData?.filter((sales) => sales.guid === guid);
    return filteredsales[0];
  }

  const MySwal = withReactContent(Swal);

  // Handle the click event to delete a Sales Return
  const handleDeleteClick = (obj) => {
    MySwal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      cancelButtonColor: "#ff0000",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const objsales = new InvSales();
          objsales.id = obj.id;
          objsales.guid = obj.guid;
          objsales.branch = branch;
          objsales.isDeleted = true;
          objsales.updatedUser = `{${userId?.id}}`;
          objsales.currency = "00000000-0000-0000-0000-000000000000";
          const response = await deleteSales(objsales);
          if (response === true) {
            MySwal.fire({
              title: "Deleted!",
              text: "The  has been deleted.",
              icon: "success",
              confirmButtonColor: "#00ff00",
              confirmButtonText: "OK",
            }).then(() => {
              handlesalesData(); // Refresh the list
            });
          } else {
            MySwal.fire({
              title: "Error!",
              text: "Something went wrong.",
              icon: "error",
              confirmButtonColor: "#ff0000",
              confirmButtonText: "OK",
            });
          }
        } catch (error) {
          console.error("Error deleting sales return:", error);
          MySwal.fire({
            title: "Error!",
            text: "Something went wrong.",
            icon: "error",
            confirmButtonColor: "#ff0000",
            confirmButtonText: "OK",
          });
        }
      }
    });
  };

  /* ---------------- list ---------------- */
  const warehouses = useMemo(
    () => (Array.isArray(wareHouseList) ? wareHouseList : []),
    [wareHouseList]
  );
  const warehouseMap = useMemo(
    () => Object.fromEntries(warehouses.map((w) => [w.guid, w.name || "Unnamed Warehouse"])),
    [warehouses]
  );

  // one flat record per return; the keys match the column definitions
  const rows = useMemo(
    () =>
      salesData.map((inv) => {
        const pay = SALES_PAYMENTS.find((p) => p.v === inv.salesPaymentType);
        return {
          guid: inv.guid,
          raw: inv,
          date: dateOf(inv.invdate),
          // the old "Invoice Date" column showed invdate as well
          invoiceDate: dateOf(inv.invdate),
          billNo: inv.entrynumber || "",
          customer: inv.customer?.name || inv.customerName || "Unknown Customer",
          customerGuid: inv.customer?.guid,
          refNo: inv.refNo || "",
          warehouse: warehouseMap[inv.location?.guid] || inv.location?.name || "",
          warehouseGuid: inv.location?.guid,
          payment: pay?.t || "Unknown",
          paymentType: inv.salesPaymentType,
          items: (inv.invSalesDetails || []).length,
          total: num(inv.grossTotal),
          additional: num(inv.additionalAmt),
          discount: num(inv.discountTotal),
          roundOff: num(inv.roundOff),
          tax: num(inv.taxTotal),
          net: num(inv.netTotal),
          lines: inv.invSalesDetails || [],
        };
      }),
    [salesData, warehouseMap]
  );

  const columns = useMemo(
    () => [
      { k: "date", t: "Date", type: "date", ago: true },
      { k: "billNo", t: "Return", type: "doc" },
      { k: "customer", t: "Customer Name", type: "party" },
      { k: "refNo", t: "Reference No" },
      {
        k: "payment",
        t: "Status",
        type: "chip",
        chip: (r) => ({ text: r.payment, tone: SALES_PAYMENTS.find((p) => p.v === r.paymentType)?.tone }),
      },
      { k: "warehouse", t: "Warehouse", off: true },
      { k: "items", t: "Items", type: "int", off: true },
      { k: "invoiceDate", t: "Invoice Date", type: "date" },
      { k: "total", t: "Gross", type: "money", off: true },
      { k: "discount", t: "Discount", type: "money", off: true },
      { k: "tax", t: "Tax", type: "money", off: true },
      { k: "net", t: "Net Amount", type: "money" },
    ],
    []
  );

  const tabs = useMemo(() => [{ id: "all", label: "Sales Return" }], []);

  const filters = useMemo(
    () => [
      {
        key: "customers",
        label: "Customer",
        items: (customerList || []).map((c) => ({ v: c.guid, t: c.name || "—" })),
        match: (r, v) => v.includes(r.customerGuid),
      },
      {
        key: "warehouses",
        label: "Warehouse",
        items: warehouses.map((w) => ({ v: w.guid, t: w.name || "Unnamed Warehouse" })),
        match: (r, v) => v.includes(r.warehouseGuid),
      },
      {
        key: "payments",
        label: "Status",
        items: SALES_PAYMENTS.map((p) => ({ v: p.v, t: p.t })),
        match: (r, v) => v.includes(r.paymentType),
      },
    ],
    [customerList, warehouses]
  );

  const searchMatch = (r, q) => {
    const hit = (s) => String(s || "").toLowerCase().includes(q);
    return (
      hit(r.billNo) ||
      hit(r.customer) ||
      hit(r.refNo) ||
      hit(r.date) ||
      String(r.net).includes(q) ||
      r.lines.some((l) => hit(l?.product?.name) || hit(l?.product?.code))
    );
  };

  const drawerContent = (r) => ({
    title: r.customer,
    subtitle: [r.billNo, dmy(r.date), r.refNo].filter(Boolean).join("  ·  "),
    avatarKey: r.customer,
    meta: [
      { k: "Warehouse", v: r.warehouse },
      { k: "Status", v: r.payment },
      { k: "Reference no", v: r.refNo },
      { k: "Items", v: intg(r.items) },
    ],
    lines: {
      title: "Return lines",
      columns: [
        { t: "Item" },
        { t: "Qty", align: "right" },
        { t: "Rate", align: "right" },
        { t: "Disc", align: "right" },
        { t: "Amount", align: "right" },
      ],
      rows: r.lines.map((l) => [
        <>
          <div className="axr-nm">{l?.product?.name || "Unknown Item"}</div>
          <div className="axr-cd">{[l?.product?.code, l?.unit?.name].filter(Boolean).join(" · ")}</div>
        </>,
        intg(l?.quantity),
        money(l?.price),
        num(l?.discAmt) ? money(l.discAmt) : "—",
        money(l?.netAmt),
      ]),
    },
    totals: [
      { l: "Gross", v: money(r.total) },
      { l: "Discount", v: r.discount ? "−" + money(r.discount) : "0.00" },
      { l: "Additional", v: money(r.additional) },
      { l: "VAT", v: money(r.tax) },
      { l: "Round off", v: money(r.roundOff) },
    ],
    net: { l: "Net amount", v: money(r.net) },
  });

  return (
    <TransactionScreen
      title="Sales Return"
      subtitle="Manage sales here"
      unit="returns"
      rows={rows}
      columns={columns}
      tabs={tabs}
      filters={filters}
      searchMatch={searchMatch}
      searchPlaceholder="Return no, customer, reference, item, amount…"
      sortOptions={[
        { v: "date:-1", t: "Newest first" },
        { v: "date:1", t: "Oldest first" },
        { v: "net:-1", t: "Largest amount" },
        { v: "net:1", t: "Smallest amount" },
        { v: "customer:1", t: "Customer A–Z" },
      ]}
      exportName="Sales return"
      onRefresh={handlesalesData}
      canAdd={permit?.add}
      newLabel="New return"
      onNew={() => {
        setModalMode("add");
        setModalOpen(true);
      }}
      canEdit={permit?.edit}
      onEdit={(r) => handleEditClick(r.guid)}
      editLabel="Edit return"
      canDelete={permit?.deletion}
      onDelete={(r) => handleDeleteClick(r.raw)}
      drawerContent={drawerContent}
      keysDisabled={modalOpen}
    >
      {modalOpen && (
        <SalesReturnModal
          mode={modalMode}
          data={modalMode === "edit" ? updateData : {}}
          handleClose={() => setModalOpen(false)}
          handleRefresh={() => {
            handlesalesData();
          }}
        />
      )}
    </TransactionScreen>
  );
};

export default SalesReturn;
